import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div``

export const OpenButton = styled.div`
  ${tw`lg:hidden`};
`

export const ApplyButton = styled.div`
  ${tw`fixed bottom-0 left-0 right-0 px-8 pb-8 lg:hidden`};
  background: linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
`

export const SelectWrapper = styled.div`
  ${tw`hidden lg:block`};
`

export const RadioInputsWrapper = styled.div`
  ${tw`fixed z-40 top-0 left-0 w-screen h-screen p-8 pb-36 overflow-auto`};
  ${({ $open }) => ($open ? tw`block` : tw`hidden`)};
  ${tw`lg:hidden`};
  background-color: var(--color-bg);
  overscroll-behavior: contain;

  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
`
